import { getFirstQueryParam } from '@jusbrasil-web/shared-utils-url'
import { GetServerSideProps } from 'next'
import { ParsedUrlQuery } from 'querystring'
import { URLSearchParams } from 'url'

import { BASE_PATH_B2B, ROUTES } from '../../constants'
import { getBasePath } from '../../utils/base-path'

function buildQueryString(query: ParsedUrlQuery, excludeKeys: string[] = []): string {
  const searchParams = new URLSearchParams()
  Object.entries(query).forEach(([key, value]) => {
    if (!excludeKeys.includes(key)) {
      const paramValue = Array.isArray(value) ? value[0] : value
      if (paramValue) {
        searchParams.set(key, paramValue)
      }
    }
  })
  return searchParams.toString()
}

export function SignupPage() {
  return null
}

const getServerSideProps: GetServerSideProps = async (ctx) => {
  const pathname = ctx.resolvedUrl?.split('?')[0] ?? ''
  const basePath = getBasePath(pathname)
  const magicLink = getFirstQueryParam(ctx.query.magic_link)

  const signupDetailsPath =
    basePath === BASE_PATH_B2B ? ROUTES.B2B.SIGN_UP.DETAILS : ROUTES.SIGN_UP.DETAILS
  if (magicLink) {
    const queryString = buildQueryString(ctx.query, ['magic_link'])
    return {
      redirect: {
        destination: `${signupDetailsPath}/${magicLink}${queryString ? `?${queryString}` : ''}`,
        permanent: false,
      },
    }
  }

  const loginQueryString = buildQueryString(ctx.query)
  return {
    redirect: {
      destination: `${ROUTES.SIGN_IN.BEGIN}${loginQueryString ? `?${loginQueryString}` : ''}`,
      permanent: false,
    },
  }
}

export const SignupPageExports = {
  getServerSideProps,
}
